// T3-B sponsored motif (PR 4, 2026-05-07): sponsors 管理用 MobX store。
// LandmarkStore パターン踏襲。

import { SponsorApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class SponsorStore extends BaseStore {
    sponsors: any[] = [];
    sponsor: any = null;
    total: number = 0;
    api: SponsorApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            sponsors: observable,
            sponsor: observable,
            total: observable,
            list: flow.bound,
            getById: flow.bound,
            create: flow.bound,
            update: flow.bound,
            remove: flow.bound
        });
        this.api = new SponsorApi();
    }

    *list(searchParams?: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.list, searchParams);
            if (res?.ok) {
                this.sponsors = res.data?.items ?? [];
                this.total = res.data?.total ?? 0;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *getById(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getById, id);
            if (res?.ok) {
                this.sponsor = res.data;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *create(payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.create, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *update(payload: { id: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.update, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *remove(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.remove, id);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }
}
